<div class="flex h-full flex-col gap-1.5 overflow-hidden py-1.5" data-cy="kala-wallet">
	@if (showLoading()) {
		<div class="flex grow items-center justify-center" data-cy="wallet-loading">
			<ui-loading message="درحال بارگذاری ..." />
		</div>
	} @else if (readFailed()) {
		<ui-empty-state
			class="grow items-center"
			data-cy="wallet-error"
			variant="error"
			iconName="alert-box"
			title="خطایی رخ داد!"
			primaryButtonLabel="تلاش مجدد"
			[showDescription]="false"
			[showButton]="true"
			(primaryClicked)="onRetry()" />
	} @else {
		<!-- The page itself never scrolls: only «تراکنش‌های اخیر»'s rows do, under its title. -->
		<app-wallet-balance-status
			class="shrink-0"
			[amountsHidden]="amountsHidden()"
			[collapsed]="balanceCollapsed()"
			(otherWalletsRequested)="onOtherWalletsRequested()" />
		<app-wallet-actions class="shrink-0" (actionRequested)="onActionRequested($event)" />
		<app-last-active-transfers (scrolled)="onHistoryScroll($event)" />
	}
</div>

<app-commodity-access-denied-bottom-sheet #accessDeniedSheet />
<app-other-wallets-bottom-sheet #otherWalletsSheet [amountsHidden]="amountsHidden()" />

@if (paymentResult(); as result) {
	<app-deposit-payment-result [result]="result" (dismissed)="onPaymentResultDismissed()" />
}
